import React from 'react'

const AuctionDateNotDecidedMessage = () => (
    <div className="bg-[#217bf0] sm:mt-0 mt-[40px] text-md lg:text-[1vw] shadow tracking-wider text-white text-center p-[10px] sm:p-[0.7vw] font-bold">
      Auction date is not decided yet, Be one on the top of bidding list
    </div>
  );

export default AuctionDateNotDecidedMessage